import { MessageRedactedEntry } from 'lib-shared-legacy-types';

import {
  getLogEntryAuthorName,
  LogEntry,
} from 'components/activityLog_old/components/activityTypes/logEntry';
import { UserLink } from 'components/activityLog_old/components/activityTypes/userLink/userLink';

type MessageRedactedProps = {
  entry: MessageRedactedEntry;
};

export const MessageRedacted = ({
  entry,
}: MessageRedactedProps): JSX.Element => {
  const textRedactedMessage = `Message text was redacted ${entry.number_of_deleted_files ? ' and ' : ''}`;
  const filesDeletedMessage = `${entry.number_of_deleted_files} file(s) were deleted`;
  const logEntryText = `${entry.was_text_redacted ? textRedactedMessage : ''}${entry.number_of_deleted_files ? filesDeletedMessage : ''} by `;

  const authorLink = (
    <UserLink userId={entry.author.id}>{getLogEntryAuthorName(entry)}</UserLink>
  );

  const text = (
    <>
      {logEntryText} {authorLink}
    </>
  );

  return <LogEntry entry={entry} text={text} />;
};
